import React, { useState } from 'react'
import { PlusCircle, } from 'lucide-react';


const AddPublication = () => {
      const [publications, setPublications] = useState([]);
      // Form state
      const [publicationForm, setPublicationForm] = useState({ 
        image: '', 
        title: '', 
        date: '', 
        description: '', 
        pdfUrl: '', 
        desc1: '', 
        desc2: '', 
        desc3: '', 
        desc4: '', 
        flipbook: '', 
        tags: [] 
      });
      const [showNotification, setShowNotification] = useState(false);
      const [notificationMessage, setNotificationMessage] = useState('');

      // Form handlers
      const handlePublicationChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'image') {
          setPublicationForm({ ...publicationForm, [name]: files[0] }); // storing File object
        } else {
          setPublicationForm({ ...publicationForm, [name]: value });
        }
      };

      const handleAddPublication = async (e) => {
        e.preventDefault();
      
        const formData = new FormData();
        formData.append('title', publicationForm.title);
        formData.append('date', publicationForm.date);
        formData.append('description', publicationForm.description);
        formData.append('desc1', publicationForm.desc1);
        formData.append('desc2', publicationForm.desc2);
        formData.append('desc3', publicationForm.desc3);
        formData.append('desc4', publicationForm.desc4);
        formData.append('flipbook', publicationForm.flipbook);
        formData.append('tags', JSON.stringify(publicationForm.tags)); // Tags as JSON array
      
        if (publicationForm.image) {
          formData.append('image', publicationForm.image);
        }
      
        if (publicationForm.pdf) {
          formData.append('pdf', publicationForm.pdf);
        }
      
        try {
          const response = await fetch('/api/publications/add', {
            method: 'POST',
            body: formData
          });
      
          if (!response.ok) {
            throw new Error('Failed to add publication');
          }
      
          const result = await response.json();
      
          // Update local state if needed
          setPublications([...publications, result.publication]);
      
          // Reset form
          setPublicationForm({ 
            image: '', title: '', date: '', description: '', pdf: '', 
            desc1: '', desc2: '', desc3: '', desc4: '', flipbook: '', tags: [] 
          });
      
          showNotificationAlert('Publication added successfully!');
        } catch (err) {
          console.error('Error:', err);
          showNotificationAlert('Failed to add publication.');
        }
      };
      
      
      const showNotificationAlert = (message) => {
        setNotificationMessage(message);
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
        }, 3000);
      };

  return (
            <div className="bg-white shadow rounded-lg overflow-hidden p-8">
                <div className="px-6 py-5 border-b border-gray-200">
                  <h3 className="text-2xl font-bold leading-6 text-gray-900">Add Publication</h3>
                  <p className="mt-1 text-sm text-gray-500">Add research papers, articles, or other academic publications</p>
                </div>

                <form onSubmit={handleAddPublication} className="p-6 space-y-6">
                  <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                    
                    <div className="sm:col-span-6">
                      <label htmlFor="image" className="block text-sm font-medium text-gray-700">Upload Image</label>
                      <input 
                        type="file" 
                        name="image" 
                        id="image" 
                        accept="image/*" 
                        onChange={handlePublicationChange} 
                        className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100" 
                      />
                    </div>

                    <div className="sm:col-span-3">
                      <label htmlFor="title" className="block text-sm font-medium text-gray-700">Title</label>
                      <input 
                        type="text" 
                        name="title" 
                        id="title" 
                        value={publicationForm.title} 
                        onChange={handlePublicationChange} 
                        required 
                        className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                      />
                    </div>

                    <div className="sm:col-span-3">
                      <label htmlFor="date" className="block text-sm font-medium text-gray-700">Date</label>
                      <input 
                        type="date" 
                        name="date" 
                        id="date" 
                        value={publicationForm.date} 
                        onChange={handlePublicationChange} 
                        required 
                        className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" 
                      />
                    </div>

                    <div className="sm:col-span-6">
                      <label htmlFor="description" className="block text-sm font-medium text-gray-700">Short Description</label>
                      <textarea 
                        name="description" 
                        id="description" 
                        rows="2" 
                        value={publicationForm.description} 
                        onChange={handlePublicationChange} 
                        className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                      />
                    </div>

                    {["desc1", "desc2", "desc3", "desc4"].map((field, idx) => (
                      <div className="sm:col-span-6" key={field}>
                        <label htmlFor={field} className="block text-sm font-medium text-gray-700">
                          Description Paragraph {idx + 1}
                        </label>
                        <textarea 
                          name={field} 
                          id={field} 
                          rows="3" 
                          value={publicationForm[field]} 
                          onChange={handlePublicationChange} 
                          className="mt-1 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md"
                        />
                      </div>
                    ))}

                    <div className="sm:col-span-6">
                      <label htmlFor="pdf" className="block text-sm font-medium text-gray-700">Upload PDF</label>
                      <input 
                        type="file" 
                        name="pdf" 
                        id="pdf" 
                        accept="application/pdf" 
                        onChange={handlePublicationChange} 
                        className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100" 
                      />
                    </div>

                    <div className="sm:col-span-6">
                      <label htmlFor="flipbook" className="block text-sm font-medium text-gray-700">Flipbook URL</label>
                      <input 
                        type="url" 
                        name="flipbook" 
                        id="flipbook" 
                        value={publicationForm.flipbook} 
                        onChange={handlePublicationChange} 
                        className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                      />
                    </div>
                  </div>

                  <div className="pt-5">
                    <div className="flex justify-end">
                      <button
                        type="button"
                        className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      >
                        <PlusCircle className="h-4 w-4 mr-2" />
                        Add Publication
                      </button>
                    </div>
                  </div>
                </form>
            </div>
  )
}

export default AddPublication